<template>
	<label :class="['button', 'button-primary', { 'disabled': loading }]">
		<span>{{ name }} <i class="glyphicon glyphicon-upload"></i></span>
		<input type="file" name="file" class="j-file-loader-inp" ref="file" style="display: none;" @change="_handleChangeUploadFile">
	</label>
</template>

<script>
	import axios from 'axios'
	import urlUtil from '../../util-url.js'

  export default {
    props: {
    	name: {
				type: String,
				default: 'Импорт данных из файла'
			},
			context: {
				type: String,
				required: true
			}
		},
		data () {
    	return {
    		loading: false
			}
		},
		methods: {
			_handleChangeUploadFile (el) {
				let files = el.target.files || el.dataTransfer.files
				if (!files.length)
					return

				const file = el.target.files[0]

				this._handleLoadService(file).then(() => {
					this.$refs.file.value = ''
					this.$emit('success')
					this.$notify({ type: 'success', text: 'Обновление успешно завершено' })
				}).catch(() => {
					this.$refs.file.value = ''
					this.$notify({ type: 'error', text: 'Обновление не удалось. Возникла ошибка' })
				})
			},
			_handleLoadService (file) {
				return new Promise((resolve, reject) => {
					this.loading = true

					let data = new FormData()
					data.append('file', file)
					data.append('redirectTo', window.location.href)

					axios.post(urlUtil.getDomain() + this.context, data, {  headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
						this.loading = false
						resolve && resolve()
					}).catch((error) => {
						this.loading = false
						reject && reject(error)

						throw new Error('Error upload file')
					})
				})
			}
		}
  }
</script>
